const unverifiedUser = {
  notVerified: 'Your customer account has not yet been verified. Please verify your account by clicking the link in the email we sent you.',
  resendEmail: 'Resend email',
  modal: {
    title: 'Your customer account has not yet been verified.',
    description: 'Please verify your account by clicking on the link in the email we sent you after you registered. You can then log in with your user data. If in doubt, also check the spam folder.',
  },
  resendPage: {
    title: 'Didn\'t receive verification email?',
    content: 'If you did not receive an email to verify your customer account, please enter your email address so that we can resend the verification email to you.',
    yourEmail: 'Your email address',
    incorrectEmail: 'If the email address is incorrect, you can of course change it.',
    sendRequest: 'send again',
    changeEmail: 'change email',
  },
}

export default unverifiedUser
